/* src/app/forms/system/system.component.scss */
.view-component-body {
  height: 50%;
  display: flex;
  flex-direction: row;
}
.mat-mdc-card-actions {
  float: right;
}
.toolbar {
  font-size: 16px;
  flex: 1 1 auto;
}
.card {
  margin: 10px;
  width: 50%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-header {
  font-size: large;
  text-decoration: underline;
}
.central {
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
}
.mat-mdc-card-content {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  flex-direction: row;
}
button {
  height: 60px;
  width: 50%;
}
/*# sourceMappingURL=system.component.css.map */
